<!-- src/components/GlobalLoader.vue -->
<template>
  <div
    v-if="isLoading"
    class="fixed z-50 inset-0 flex items-center justify-center bg-slate-200 bg-opacity-50">
    <div class="loader"></div>
  </div>
</template>

<script setup>
import { computed } from "vue"
import { useLoaderStore } from "@/stores/loader.js"

const loaderStore = useLoaderStore()
const isLoading = computed(() => loaderStore.isLoading)
</script>

<style scoped lang="scss">
@import "@/assets/scss/tokens.scss";
.loader {
  border: 8px solid #acacac;
  border-top: 8px solid $primary-color;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
